import { render, staticRenderFns } from "./customContent.vue?vue&type=template&id=dd07acf8&scoped=true&"
import script from "./customContent.vue?vue&type=script&lang=js&"
export * from "./customContent.vue?vue&type=script&lang=js&"
import style0 from "./customContent.vue?vue&type=style&index=0&id=dd07acf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd07acf8",
  null
  
)

export default component.exports